<script>
  import { productDataStore } from "../../stores/ProductData.js";

  export let frontPreviewUrl;
  export let backPreviewUrl;

  function changeSide(side) {
    $productDataStore.side = side;
  }
</script>

<div class="front-back-container">
  <div
    class="front-back"
    class:active={$productDataStore.side === "front"}
    on:click={() => changeSide("front")}
  >
    <img src={frontPreviewUrl} alt="toggle front back preview" />
    <div class="label">Front</div>
  </div>
  <div
    class="front-back"
    class:active={$productDataStore.side === "back"}
    on:click={() => changeSide("back")}
  >
    <img src={backPreviewUrl} alt="toggle front back preview" />
    <div class="label">Back</div>
  </div>
</div>

<style>
  .front-back-container {
    position: absolute;
    margin-bottom: 1rem;
    margin-right: 1rem;
    right: 0;
    bottom: 0;
    padding: 0.5rem;
    z-index: 10;
    background-color: white;
    box-shadow: 1px 1px 0.5rem rgba(0, 0, 0, 0.15);
    border-radius: 5px;
  }

  .front-back-container img {
    max-width: 40px;
  }

  .front-back-container .label {
    text-align: center;
    font-size: 1.1rem;
  }

  .front-back:first-child {
    margin-bottom: 1rem;
  }

  .front-back.active {
    border-bottom: 2px solid #fe5900;
  }

  .front-back:hover {
    cursor: pointer;
  }
</style>
